import React from "react";
import { Text, Spacer, Image } from "../dynamic.components";
import table from "src/assets/images/footprint/size_table.png";
import SubHotspots from "../Sub-hotspots";

export const Footprint: React.FC = () => {
  return (
    <>
      <div className="c-sidebar__body">
        <Text text="The ÄKTA readyflux™ filtration system provides excellent filtration capabilities in a compact design, enabling efficient use of clean room floor space." />

        <Spacer x={2} />
        <SubHotspots sublinkId="1-1" />
        <Spacer />
        <Image
          images={[
            {
              src: table,
              alt: "Table",
              customWidth: "60%",
            },
          ]}
        />
      </div>
    </>
  );
};
